// OP_0 {pubKeyHash}

const bscript = require('../../script')
const OPS = require('bitcoin-ops')

function check (script) {
  const buffer = bscript.compile(script)

  return buffer.length === 22 &&
    buffer[0] === OPS.OP_0 &&
    buffer[1] === 0x14
}
check.toJSON = function () { return 'Witness pubKeyHash output' }

module.exports = {
  check
}



//////////////////
// WEBPACK FOOTER
// ./~/bitcoinjs-lib/src/templates/witnesspubkeyhash/output.js
// module id = 183
// module chunks = 0